export default __webpack_public_path__ + "static/media/IncomingcallLogo.fef4493a.svg";